import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { mergeRouteParams } from 'app/helpers';
import { UsergroupService } from 'app/services';

export const packageModulesGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const usergroupService = inject(UsergroupService);

    const params = mergeRouteParams(route);

    if (!params.usergroupHash) {
        router.navigate(['/']);
        return false;
    }

    return usergroupService.getUsergroup(params.usergroupHash).pipe(
        map(({ data: { usergroup } }) => {
            const businessPackage = usergroup.active_businesspackage;

            if (businessPackage && businessPackage[route.data.package_module]) {
                return true;
            }

            router.navigate(['/']);
            return false;
        }),
    );
};
